import { Autocomplete, Box, Chip, Stack, TextField, Typography } from "@mui/material"
import * as React from 'react'
import { Domain } from '../../../store/Event'

interface Props {
    onChange: (v: Domain[]) => void
    value: Domain[]
    disabled?: boolean
    minWidth?: string
}

const domainOptions = [
    { value: Domain.RallySafe, label: 'RallySafe' },
    { value: Domain.RallySafeLite, label: 'RSLite Competition' },
    { value: Domain.RallySafeRecce, label: 'RSLite Recce' },
    { value: Domain.RSLiteGeneric, label: 'RSLite Generic' },
]

export const DomainMultiSelect: React.FunctionComponent<Props> = ({ value, onChange, disabled, minWidth }) => {
    const selectedDomains = domainOptions.filter(opt => value.includes(opt.value))

    return (
        <Autocomplete
            sx={{ minWidth: minWidth || '260px' }}
            size={'small'}
            multiple
            value={selectedDomains}
            disabled={disabled}
            onChange={(e, v) => onChange(v.map(x => x.value))}
            options={domainOptions}
            getOptionLabel={(option) => option.label}
            renderTags={(value, getTagProps) =>
                value.map((option, index) => (
                    <Chip {...getTagProps({ index })} size='small' label={option.label} />
                ))
            }
            renderOption={(props, option) => (
                <Box component="li" {...props}>
                    <Stack spacing={1} alignItems='center' direction='row'>
                        <Typography>{option.label}</Typography>
                    </Stack>
                </Box>
            )}
            renderInput={(params) => (
                <TextField {...params} label='Domains' />
            )}
        />
    )
}
